export const REPORT_STATUS = {
  NEW: 'NEW',
  SUBMITTED: 'SUBMITTED',
  WAITING_FOR_RELEASE: 'WAITING_FOR_RELEASE',
  RESUBMITTED: 'RESUBMITTED',
  EVALUATION_COMPLETED: 'EVALUATION_COMPLETED',
  EXPIRED: 'EXPIRED'
}
